import { GameActions, IGameLoadData } from 'State/Game/GameActions';
import Game from 'Game';
import { isNative } from 'Utility/Platform';
import { UIActions } from 'State/UI/UIActions';
import { PopupID } from 'State/UI/PopupID';
import { PlayerActions } from 'State/Player/PlayerActions';
import { ConnectFbSplashScreen } from 'System/UI/Menu/ConnectFbSplashScreen';
import { AuthPlatform } from '@sgorg/mobile-dev-tools';
import { PlatformActions } from 'State/Game/PlatformActions';
import { IGameState } from 'State/Game/IGameState';
import { FBTrackingEvent } from 'Utility/Tracking/FBTrackingEvent';
import { sendEvent, track } from 'Utility/Tracking/Track';
import { FTUXTrackingEventName } from 'Utility/Tracking/TrackingEvent';
import { handleIAP } from 'System/Preload/HandleIAP';
import { runAsyncPreloadTasks } from './RunAsyncPreloadTasks';
import { handleCrossPromo } from 'System/Preload/HandleCrossPromo';

export async function startGame(gameLoadedState: IGameLoadData) {
    GameActions.setLoadedData(gameLoadedState);

    Game.player.data.start();

    handleIAP();

    if (!Game.store.getState().playerState.gdprCompliance && isNative()) {
        UIActions.showPopup(PopupID.GDPR_POPUP, {});
        await Game.store.waitFor(PlayerActions.agreeWithTerms);
    }

    if (ConnectFbSplashScreen.shouldShow()) {
        UIActions.showPopup(PopupID.CONNECT_FB_SPLASH_SCREEN, {});
        await Game.store.waitFor(
            UIActions.hidePopup,
            action => action.payload.popupID === PopupID.CONNECT_FB_SPLASH_SCREEN
        );
    }

    // Silent sign in
    if (isNative()) {
        const platform = Game.sdk.isFacebookConnected() ? AuthPlatform.Facebook : AuthPlatform.Native;
        Game.store.dispatch(PlatformActions.signIn(platform, true));
    }

    const preloadState: IGameState = Game.store.getState();
    if (!preloadState.playerState.FBEvents.includes(FBTrackingEvent.FTUE_02_LoadingCompleted)) {
        Game.sdk.gameTracking(FBTrackingEvent.FTUE_02_LoadingCompleted);
        PlayerActions.addFTUETrackingEvent(FBTrackingEvent.FTUE_02_LoadingCompleted);

        track('stepId', 2);
        track('stepName', FBTrackingEvent.FTUE_02_LoadingCompleted);
        sendEvent(FTUXTrackingEventName.ftux, Game.store.getState());
    }

    // Try/catch to allow cross promo to fail and not effect game initialization.
   /* try {
        await handleCrossPromo();
    } catch (e) {
        console.warn(e);
    }*/

    GameActions.gameLoaded();

    // Asynchronous tasks - do not await.
    runAsyncPreloadTasks();
}
